export default function size(size) {
  const globalSize = getComputedStyle(document.documentElement).fontSize;
  if (globalSize === '16px') return size;
  return (globalSize.slice(0, -2) / 16) * size;
}
